// utils/checkoutValidation.js

/**
 * Validates customer information for checkout
 * @param {Object} customerInfo - Customer information object
 * @param {string} customerInfo.firstName - Customer's first name
 * @param {string} customerInfo.lastName - Customer's last name
 * @param {string} customerInfo.email - Customer's email address
 * @param {string} customerInfo.phone - Customer's phone number
 * @returns {Object} Object containing validation errors, empty if no errors
 */
export const validateCustomerInfo = (customerInfo) => {
  const errors = {};

  if (!customerInfo.firstName?.trim()) {
    errors.firstName = 'First name is required';
  }

  if (!customerInfo.lastName?.trim()) {
    errors.lastName = 'Last name is required';
  }

  // Email is optional, but validate format if provided
  if (customerInfo.email?.trim()) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customerInfo.email)) {
      errors.email = 'Please enter a valid email address';
    }
  }

  if (!customerInfo.phone?.trim()) {
    errors.phone = 'Phone number is required';
  } else if (
    !/^\+?[\d\s\-()]{10,}$/.test(customerInfo.phone.replace(/\s/g, ''))
  ) {
    errors.phone = 'Please enter a valid phone number';
  }

  return errors;
};
